import CustomerModelBase from '../_generated/modelBases/customer-model-base';

export default class CustomerModel extends CustomerModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
